export default __webpack_public_path__ + "static/media/007-parking.c84744cd.png";